import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import {
    LegacyModuleAccessInitializedMessage,
    MessagingService
} from '../../system-services';

@Injectable({
    providedIn: 'root'
})
export class LegacyModuleGuard {
    private hasInitialized$ = new Subject<boolean>();

    constructor(private messageService: MessagingService) {
        this.hasInitialized$.next(false);

        this.messageService
            .listenFor<LegacyModuleAccessInitializedMessage>(
                LegacyModuleAccessInitializedMessage
            )
            .subscribe(() => this.hasInitialized$.next(true));
    }

    canLoad(): Observable<boolean> {
        return this.hasInitialized$;
    }

    canActivate(): Observable<boolean> | Observable<UrlTree> {
        return this.hasInitialized$;
    }

    canActivateChild(): Observable<boolean> | Observable<UrlTree> {
        return this.hasInitialized$;
    }
}
